// Shared helpers for the Custom Field Builder (Inventory + Billing).
import { Type, Hash, ListChecks, Calendar, ToggleRight, Camera } from 'lucide-react';

export const FIELD_TYPES = [
  { value: 'text', label: 'Text', icon: Type, hint: 'Short free text (e.g. Tailor name)' },
  { value: 'number', label: 'Number', icon: Hash, hint: 'Numeric value (e.g. Alteration cost)' },
  { value: 'dropdown', label: 'Dropdown', icon: ListChecks, hint: 'Choose one from preset options' },
  { value: 'date', label: 'Date', icon: Calendar, hint: 'Pick a date (e.g. Delivery date)' },
  { value: 'boolean', label: 'Yes / No', icon: ToggleRight, hint: 'On/off toggle (e.g. Gift wrap)' },
  { value: 'photo', label: 'Photo', icon: Camera, hint: 'Capture a photo from the camera' },
];

export const typeMeta = (t) => FIELD_TYPES.find((x) => x.value === t) || FIELD_TYPES[0];

// Fields that apply to a context ('inventory' | 'billing'), active only, ordered.
export function fieldsFor(defs, context) {
  return (defs || [])
    .filter((f) => f && f.active !== false && f.applies_to && f.applies_to[context])
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function hasValue(type, v) {
  if (type === 'boolean') return v === true; // only "yes" counts as filled for required
  if (type === 'photo') return Array.isArray(v) ? v.length > 0 : !!(v && v.path);
  if (type === 'number') return v !== '' && v !== null && v !== undefined && !Number.isNaN(Number(v));
  return v !== '' && v !== null && v !== undefined;
}

// Returns { [key]: 'error message' } for required fields missing a value.
export function validateCustom(defs, context, values) {
  const errs = {};
  for (const f of fieldsFor(defs, context)) {
    if (f.required && !hasValue(f.type, (values || {})[f.key])) {
      errs[f.key] = `${f.name} is required`;
    }
  }
  return errs;
}

// Strip empty values so we only persist what was actually filled.
export function cleanCustomValues(defs, context, values) {
  const out = {};
  for (const f of fieldsFor(defs, context)) {
    const v = (values || {})[f.key];
    if (hasValue(f.type, v)) out[f.key] = f.type === 'number' ? Number(v) : v;
    else if (f.type === 'boolean' && v === true) out[f.key] = true;
  }
  return out;
}
